import { render, staticRenderFns } from "./kbankstatement.vue?vue&type=template&id=031f3d89&scoped=true&"
import script from "./kbankstatement.vue?vue&type=script&lang=js&"
export * from "./kbankstatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031f3d89",
  null
  
)

export default component.exports